import { Edit, RemoveRedEye, Delete, FeaturedPlayList, DoneAllOutlined, Info } from '@material-ui/icons';

const EditIcon = Edit;
const DeleteIcon = Delete;
const FeaturedPlayListIcon = FeaturedPlayList;
const DoneAllOutlinedIcon = DoneAllOutlined;
const InfoIcon = Info;

export { EditIcon, RemoveRedEye, DeleteIcon, FeaturedPlayListIcon, DoneAllOutlinedIcon, InfoIcon }